// extracted by mini-css-extract-plugin
export var dateTimeButton = "_fx-1";
export var dateTimeButtonsContainer = "_fx-6";
export var dateTimeInputContainer = "_fx-7";
export var dateTimeWrapper = "_fx-8";
export var disabledTile = "_fx-0";
export var header = "_fx-2";
export var line = "_fx-3";
export var snoozeOption = "_fx-4";
export var time = "_fx-5";
export var todayTile = "_fx-9";
export var wrapper = "_fx-a";